// Single place to edit business details. Change values here and they update across the site.
export const SITE = {
  name: "Nutribest Superfoods",
  legalName: "Nutribest Superfoods Pvt. Ltd.",
  tagline: "Pure Nutrition. Real Superfoods.",
  email: "care@nutribest.com",
  phone: "+91 00000 00000",
  whatsapp: "+91 00000 00000",
  hours: "Mon – Sat | 9 AM – 7 PM",
  address: "Nutribest Superfoods Pvt. Ltd., India",
  social: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
    youtube: "https://youtube.com/",
    linkedin: "https://linkedin.com/",
  },
};

// Set comingSoon to false when the online store goes live.
export const LAUNCH = {
  comingSoon: true,
  message: "Our website and online store are coming soon. Thank you for your patience!",
  checkoutMessage: "Our online store is coming soon. Your basket is saved for launch day.",
};
